import { SearchEntityType } from '@newo/api/gateway';

export const MAX_VISIBLE_MATCHES = 3;

export const ENTITY_TYPE_COLORS: Record<SearchEntityType, string> = {
    [SearchEntityType.SKILL]: 'blue',
    [SearchEntityType.EVENT]: 'green',
    [SearchEntityType.FLOW]: 'orange',
    [SearchEntityType.AGENT]: 'violet'
};
